import { render } from "./OtpVerification.vue?vue&type=template&id=61d325cf&scoped=true"
import script from "./OtpVerification.vue?vue&type=script&lang=js"
export * from "./OtpVerification.vue?vue&type=script&lang=js"

import "./OtpVerification.vue?vue&type=style&index=0&id=61d325cf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d325cf"]])

export default __exports__